import React from 'react';
import { Modal } from '../../util';
import { useTranslation } from 'react-i18next';
import { makeKey } from '../../hooks/useConvertForTranslationKey';
import tutorial1 from './tutorial-1.png';
const HowToSearchModal = _ref => {
  let {
    show,
    onHide
  } = _ref;
  const {
    t
  } = useTranslation();
  const boldClass = 'font-weight-bold';
  const body = /*#__PURE__*/React.createElement("div", {
    className: "text-center"
  }, /*#__PURE__*/React.createElement("h3", null, t(makeKey('to search for a folder or file named')), ":"), /*#__PURE__*/React.createElement("h3", {
    className: "mb-4"
  }, "Engagement Management"), /*#__PURE__*/React.createElement("h3", {
    className: "mb-4"
  }, t(makeKey('you do not necessarily have to type the whole word')), ": ", /*#__PURE__*/React.createElement("span", {
    className: "font-italic"
  }, "engagement management")), /*#__PURE__*/React.createElement("h3", {
    className: "mb-4"
  }, t(makeKey('simply type about two letters from each word')), ": ", /*#__PURE__*/React.createElement("br", null), " ", /*#__PURE__*/React.createElement("span", {
    className: boldClass
  }, "en"), "gagement", /*#__PURE__*/React.createElement("span", {
    className: boldClass
  }, "ma"), "nagement"), /*#__PURE__*/React.createElement("h3", {
    className: "mb-4"
  }, t(makeKey('so what you should type is')), ": ", /*#__PURE__*/React.createElement("span", {
    style: {
      backgroundColor: 'rgba(0, 0, 0, 0.2)'
    },
    className: boldClass
  }, "en ma")), /*#__PURE__*/React.createElement("h3", {
    className: "mb-4"
  }, t(makeKey('you can see')), " Engagement Management ", t(makeKey('as our top result'))), /*#__PURE__*/React.createElement("img", {
    style: {
      width: '100%'
    },
    src: tutorial1,
    alt: "My Image"
  }));
  return /*#__PURE__*/React.createElement(Modal, {
    size: "xl",
    title: t('how_to_search_folders_and_files'),
    show: show,
    renderBody: () => body,
    onHide: onHide,
    submitText: t('yes'),
    closeText: t('close'),
    submitIcon: "done"
  });
};
export default HowToSearchModal;